import {
  Box,
  Button,
  ButtonProps,
  Container,
  MenuItem,
  Paper,
  styled,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { ReactNode, useContext, useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import variables from "../../../assets/styles/variables.module.scss";
import SmallCardAgent from "../../../Shared-ui/SharedComponents/Cards/SmallCardAgent";
import SmallCardKnowledgeBase from "../../../Shared-ui/SharedComponents/Cards/SmallCardKnowledgeBase";
import SmallCardConversations from "../../../Shared-ui/SharedComponents/Cards/SmallCardConversations";
import DashboardTab from "../../Components/DashboardTab";
import {
  StartLoading,
  StopLoading,
} from "../../../Shared-ui/Store/LoadingReducer/LoaderActions";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  ShowError,
} from "../../../Shared-ui/Store/MessageReducer/MsgActions";
import userContext from "../../../Shared-ui/Context/UserContext";
import { DASHBOARD_AGENT, DASHBOARD_STATUS ,DASHBOARD_STATUS_ADMIN} from "../../../Services/Endpoint";

// Add these imports at the top
import ButtonGroup from "@mui/material/ButtonGroup";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Grow from "@mui/material/Grow";
import Popper from "@mui/material/Popper";
import MenuList from "@mui/material/MenuList";
import CreateAgent from "../../Components/CreateAgent";
import CreateMultiAgent from "../../Components/CreateMultiAgent";
import BaseInstance from "../../../Services/AxiosInstance/BaseInstance";
import { DashboardStats } from "../../../Shared-ui/Types/Dashboard";


interface MyComponentProps {
  children?: ReactNode; // Ensure you define children prop type
}

const ColorButton = styled(Button)<ButtonProps>(({ theme }) => ({
  // borderRadius: "8px",
  color: variables.whiteColor,
  backgroundColor: variables.primaryButton,
  "&:hover": {
    backgroundColor: variables.primaryColor,
  },
}));

const DashBoard: React.FC<MyComponentProps> = ({ }) => {

  const DashboardStatsInitialState: DashboardStats = {
    agents: {
      own_agents: 0,
      shared_agents: 0,
      total_agents: 0,
      active_agents: 0,
    },
    teams: {
      teams_created: 0,
      teams_member: 0,
      active_teams: 0,
    },
    knowledge: {
      knowledge_bases: 0,
      documents: 0,
      total_files: 0,
    },
    activity: {
      total_conversations: 0,
      total_messages: 0,
      recent_conversations: 0,
      tools_available: 0,
      tools_used: 0,
    },
    storage: {
      files_count: 0,
      total_size_bytes: 0,
      total_size_mb: 0,
    },
  };

  const [dashboardStats, setDashboardStats] = useState<DashboardStats>(DashboardStatsInitialState);
  const [open, setOpen] = React.useState(false);
  const today = new Date().toLocaleDateString("en-US", {
    weekday: "long",
    month: "short",
    day: "numeric",
    year: "numeric",
  });

  const { user } = useContext(userContext);
  const user_role = user?.role;
  const isUser = user_role === "admin" || user_role === "super admin"
  
console.log(user_role,"isuser, user_role")

  const theme = useTheme();
  const dispatch = useDispatch();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [refreshTab, setRefreshTab] = useState(false);
  // const [state, dispatch] = useReducer(LoadingReducer, {})



  const handleClickOpen = () => {
    setOpen(true);
  };

  const navigate = useNavigate();

  // Add these states after other state declarations
  const [openSplit, setOpenSplit] = useState(false);
  const anchorRef = React.useRef<HTMLDivElement>(null);
  const [selectedOption, setSelectedOption] = useState(0);


  useEffect(() => {
    if (user && user.role) {
      getDashBoardData();
    }
  }, [user]);

  const getDashBoardData = async () => {
    try {
      dispatch(StartLoading());
      console.log(isUser,"isUser")
      const endpoint = isUser ? DASHBOARD_STATUS_ADMIN : DASHBOARD_STATUS;
      const data = await BaseInstance.get(`${endpoint}`).then(
        (res) => res?.data
      );

      setDashboardStats(data);
    } catch (err: any) {
      dispatch(ShowError(err?.response?.data?.statusText));
    } finally {
      dispatch(StopLoading());
    }
  };

  // Add these handlers after other function declarations
  const handleMenuItemClick = (index: number) => {
    setSelectedOption(index);
    setOpenSplit(false);
    if (index === 0) {
      setOpen(true); // For Create Agent
    } else {
      setCreateMultiAgentOpen(true); // For Create Multi Agent
    }
  };

  const handleToggle = () => {
    setOpenSplit((prevOpen) => !prevOpen);
  };

  const handleMenuClose = (event: Event) => {
    if (
      anchorRef.current &&
      anchorRef.current.contains(event.target as HTMLElement)
    ) {
      return;
    }
    setOpenSplit(false);
  };
  const capitalizeName = (name: string): string => {
    return name
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };

  const [CreateMultiAgentOpen, setCreateMultiAgentOpen] = useState(false);
  const handleAgentClose = () => {
    setOpen(false)
    setRefreshTab(prev => !prev);
  };
  const handleClose = () => {
    setOpen(false);
    setCreateMultiAgentOpen(false);
  };

  // Replace the existing ColorButton with this ButtonGroup

  return (
    <>
      <Container maxWidth="xl" sx={{ py: 4 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            pb: 3,
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: { md: "flex-end", sm: "flex-start" },
              gap: { md: "10px", sm: "0" },
              flexDirection: { md: "row", sm: "column", xs: "column" },
            }}
          >
            <Typography
              variant="h4"
              fontWeight="bold"
              sx={{
                fontSize: { sm: "34px", xs: "18px" },
              }}
            >
              Welcome {user && capitalizeName(user.full_name)}!
            </Typography>
            <Typography
              variant="subtitle1"
              fontWeight="400"
              sx={{
                fontSize: { sm: "16px", xs: "12px" },
                color: variables.primaryButton,
              }}
            >
              {/* Monday Oct 28, 2024 */}
              {today}
            </Typography>
          </Box>
          {user_role === "super admin" ? (
            <Box>
              <Button 
              variant="contained"
              startIcon={<AdminPanelSettingsIcon />}
               sx={{
                borderRadius: { sm: "8px", xs: "4px" },
                overflow: "hidden",
                boxShadow: "none",
                backgroundColor: variables.primaryButton,
                padding: "12px 16px",
                "& .MuiButton-root": {
                  color: variables.whiteColor,
                  textTransform: "capitalize",
                  fontWeight: "400",
                  whiteSpace: "nowrap",
                  "&:hover": {
                    backgroundColor: variables.primaryColor,
                  },
                },
                "& .MuiButtonGroup-firstButton": {
                  borderRight: `1px solid ${variables.whiteColor}`,
                },
              }}
              onClick={() => navigate("/admin")}>
                <Typography variant="body2">Admin Console</Typography>
              </Button>
            </Box>)
           : (
          <Box>
            <ButtonGroup
              variant="contained"
              ref={anchorRef}
              sx={{
                borderRadius: { sm: "8px", xs: "4px" },
                overflow: "hidden",
                boxShadow: "none",
                "& .MuiButton-root": {
                  color: variables.whiteColor,
                  textTransform: "capitalize",
                  fontWeight: "400",
                  whiteSpace: "nowrap",
                  "&:hover": {
                    backgroundColor: variables.primaryColor,
                  },
                },
                "& .MuiButtonGroup-firstButton": {
                  borderRight: `1px solid ${variables.whiteColor}`,
                },
              }}
              size={isSmallScreen ? "small" : "large"}
            >
              <ColorButton
                startIcon={<AddIcon />}
                aria-haspopup="menu"
                onClick={handleToggle}

              >
                Create Agent
              </ColorButton>
              {/* <ColorButton
                size="small"
                aria-controls={openSplit ? "split-button-menu" : undefined}
                aria-expanded={openSplit ? "true" : undefined}
                aria-haspopup="menu"
                onClick={handleToggle}
              >
                <ArrowDropDownIcon />
              </ColorButton> */}
            </ButtonGroup>
            <Popper
              sx={{
                zIndex: 1,
              }}
              open={openSplit}
              anchorEl={anchorRef.current}
              role={undefined}
              transition
              disablePortal
              placement="bottom-end" // Add this line
            >
              {({ TransitionProps, placement }) => (
                <Grow
                  {...TransitionProps}
                  style={{
                    transformOrigin:
                      placement === "bottom-end" ? "top right" : "bottom right",
                  }}
                >
                  <Paper
                    sx={{
                      marginTop: "8px",
                      minWidth: "200px",
                      "& .MuiList-root": {
                        padding: 0,
                      },
                      "& .MuiMenuItem-root": {
                        padding: "8px 16px",
                        borderRadius: "4px",
                      },
                    }}
                  >
                    <ClickAwayListener onClickAway={handleMenuClose}>
                      <MenuList id="split-button-menu" autoFocusItem>
                        <MenuItem
                          selected={selectedOption === 1}
                          onClick={() => handleMenuItemClick(0)}
                        >
                          Single-agent
                        </MenuItem>
                        <MenuItem
                          selected={selectedOption === 1}
                          onClick={() => handleMenuItemClick(1)}
                        >
                          Multi-agent
                        </MenuItem>
                      </MenuList>
                    </ClickAwayListener>
                  </Paper>
                </Grow>
              )}
            </Popper>
          </Box>
          )}
        </Box>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { md: "1fr 1fr 1fr" },
            gap: 4,
            gridAutoRows: "1fr",
            mt: 0,
          }}
        >
          <Box>
            <SmallCardAgent dashboardStats={dashboardStats} />
          </Box>
          <Box>
            <SmallCardKnowledgeBase dashboardStats={dashboardStats} />
          </Box>
          <Box>
            <SmallCardConversations dashboardStats={dashboardStats} />
          </Box>
        </Box>
        <Box>
          <DashboardTab refreshTab={refreshTab} />
        </Box>

        <CreateAgent open={open} handleClose={handleAgentClose} agent={null} />
        <CreateMultiAgent open={CreateMultiAgentOpen} handleClose={handleClose} multiAgent={null} />
      </Container>
    </>
  );
};

export default DashBoard;
